import React, { useEffect } from "react";
import styled from "styled-components";
import {
  QuizQuestionArea,
  QuestionOptions,
  QuestionButtonArea,
} from "../../Components/Quiz/quiz.component";

const ExamScreen = ({ title }) => {
  useEffect(() => {
    document.title = title;
  }, [title]);
  return (
    <Container>
      <QuestionButtonArea />
      <FormArea>
        <QuizQuestionArea />
        <AnswerArea>
          <QuestionOptions />
        </AnswerArea>
      </FormArea>
    </Container>
  );
};

const AnswerArea = styled.div`
  margin-top: 5%;
  margin-left: 2%;
`;

const FormArea = styled.div`
  margin-top: 10%;
  margin-left: 20%;
`;

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

export default ExamScreen;
